import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/queryClient';
import AppLayout from '@/components/layout/AppLayout';
import Skeleton from '@/components/ui/Skeleton';

const MissionsPage = lazy(() => import('@/routes/MissionsPage'));
const DashboardPage = lazy(() => import('@/routes/DashboardPage'));
const SubmitPage = lazy(() => import('@/routes/SubmitPage'));
const LeaderboardPage = lazy(() => import('@/routes/LeaderboardPage'));
const HistoryPage = lazy(() => import('@/routes/HistoryPage'));
const ReferralsPage = lazy(() => import('@/routes/ReferralsPage'));
const ConversionPage = lazy(() => import('@/routes/ConversionPage'));

function PageFallback() {
  return (
    <div className="flex flex-col gap-4">
      <Skeleton className="h-8 w-40" />
      <Skeleton className="h-32 w-full" />
      <Skeleton className="h-32 w-full" />
    </div>
  );
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route element={<AppLayout />}>
            <Route
              index
              element={
                <Suspense fallback={<PageFallback />}>
                  <MissionsPage />
                </Suspense>
              }
            />
            <Route
              path="/dashboard"
              element={
                <Suspense fallback={<PageFallback />}>
                  <DashboardPage />
                </Suspense>
              }
            />
            <Route
              path="/submit"
              element={
                <Suspense fallback={<PageFallback />}>
                  <SubmitPage />
                </Suspense>
              }
            />
            <Route
              path="/leaderboard"
              element={
                <Suspense fallback={<PageFallback />}>
                  <LeaderboardPage />
                </Suspense>
              }
            />
            <Route
              path="/history"
              element={
                <Suspense fallback={<PageFallback />}>
                  <HistoryPage />
                </Suspense>
              }
            />
            <Route
              path="/referrals"
              element={
                <Suspense fallback={<PageFallback />}>
                  <ReferralsPage />
                </Suspense>
              }
            />
            <Route
              path="/conversion"
              element={
                <Suspense fallback={<PageFallback />}>
                  <ConversionPage />
                </Suspense>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
